<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import AreaSelector from '@/components/org/AreaSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'area-selector': AreaSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organization: {
                name: null,
                logoUrl: null,
                logo: null,
                area: null,
                areaId: null,
                contact: null,
                position: null,
                sportType: null,
            },
            cityRegion: {
                areaList: null,
                areaIdList: null
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.organization.name) {
                    Toast(this.locale['organization-name-required'])
                }
                else if (!this.organization.area) {
                    Toast(this.locale['organization-area-required'])
                }
                else if (!this.organization.contact) {
                    Toast(this.locale['organization-contact-required'])
                }
                else if (!this.organization.position) {
                    Toast(this.locale['organization-position-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-organization'],
                message: this.locale['delete-organization-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onAreaSelectorDataChange(data) {
            console.log('onAreaSelectorDataChange', this.isEdit, data)
            this.organization.areaId = this.convertAreaCode2Id(data.code)
            console.log('organization.areaIdList', this.cityRegion.areaIdList, data.code)
            console.log('organization.areaId', this.organization.areaId, data.code)
            this.organization.area = data.label
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.organization.logo = data
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.organization.name 
                && this.organization.area 
                && this.organization.contact
                && this.organization.position) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            console.log('submitData', this.organization)
            if (this.validateSubmitRequired()) {
                this.organization.sportType = this.locale['sport-type-1']
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.organization
                })
            }
        },
        convertAreaCode2Id(code) {
            console.log('convertAreaCode2Id', code)
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                if (areaIdList.province_list[code]) {
                    return areaIdList.province_list[code]
                }
                else if (areaIdList.city_list[code]) {
                    return areaIdList.city_list[code]
                }
                else if (areaIdList.county_list[code]) {
                    return areaIdList.county_list[code]
                }
            }
            return '1'
        },
        convertAreaId2Code(id) {
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                for (let p in areaIdList.province_list) {
                    if (areaIdList.province_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.city_list) {
                    if (areaIdList.city_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.county_list) {
                    if (areaIdList.county_list[p] == id) {
                        return p
                    }
                }
            }
        },
    },
}
</script>

<template>
    <div class="organization-edit">
        <van-form>
            <van-field 
                name="organization-name" 
                v-model="organization.name" 
                :label="locale['organization-name-label']" :placeholder="locale['organization-name-placeholder']"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="50" 
            />
            <image-uploader
                :label="locale['organization-logo-label']"
                :description="locale['organization-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <area-selector
                :label="locale['city-region']"
                :all="locale['all']"
                :allArea="locale['whole-nation']"
                :areaList="cityRegion.areaList"
                :selectedAreaCode="convertAreaId2Code(organization.areaId)"
                :selectedAreaLabel="organization.area"
                @change-data="onAreaSelectorDataChange"
            />
            <van-cell
                class="van-cell-field"
                :title="locale['sport-type']"
                :value="locale['sport-type-1']"
            />
            <van-field 
                name="organization-contact" 
                v-model="organization.contact" 
                :label="locale['organization-contact-label']" :placeholder="locale['organization-contact-placeholder']"
                clearable
                input-align="right"
                maxlength="30"
            />
            <van-field 
                name="organization-position" 
                v-model="organization.position" 
                :label="locale['organization-position-label']" :placeholder="locale['organization-position-placeholder']"
                clearable
                input-align="right"
                maxlength="30"
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>